/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ResetPasswordToken200ResponseData
 */
export interface ResetPasswordToken200ResponseData {
  /**
   * Верификационный токен (действует 10 минут)
   * @type {string}
   * @memberof ResetPasswordToken200ResponseData
   */
  token: string
}

/**
 * Check if a given object implements the ResetPasswordToken200ResponseData interface.
 */
export function instanceOfResetPasswordToken200ResponseData(
  value: object
): value is ResetPasswordToken200ResponseData {
  if (!('token' in value) || value['token'] === undefined) return false
  return true
}

export function ResetPasswordToken200ResponseDataFromJSON(
  json: any
): ResetPasswordToken200ResponseData {
  return ResetPasswordToken200ResponseDataFromJSONTyped(json, false)
}

export function ResetPasswordToken200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResetPasswordToken200ResponseData {
  if (json == null) {
    return json
  }
  return {
    token: json['token'],
  }
}

export function ResetPasswordToken200ResponseDataToJSON(
  value?: ResetPasswordToken200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    token: value['token'],
  }
}
